<template>
  <div class="forgotPassword_box">
    <el-form :model="changePhoneForm" :rules="changePhoneRules" ref="registerRuleForm" label-width="140px" class="demo-registerRuleForm" label-position="left">
      <el-form-item label="新手机号" prop="phoneNumber">
        <el-input v-model="changePhoneForm.phoneNumber" placeholder="请输入新手机号码"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <div class="verification_code flex-be">
          <el-input class="m-r-5" v-model="changePhoneForm.code" placeholder="请输入验证码"></el-input>
          <smsSend :mobile="changePhoneForm.phoneNumber" :sms-type="'CHANGE_PHONE'"></smsSend>
        </div>
      </el-form-item>
      <div class="submit_btn_box m-t-30">
        <el-button type="primary" style="width: 100%;" @click="submitForm('registerRuleForm')">
          提 交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import smsSend from "@/components/SmsSend";
  import crypto from "@/utils/Crypto";

  export default {
    name: "changePhone",
    props: ['phone'],
    // import引入的组件需要注入到对象中才能使用
    components: {
      smsSend
    },
    data() {
      // 这里存放数据
      return {
        changePhoneForm: {
          phoneNumber: "",
          code: "",
        },
        changePhoneRules: {
          phoneNumber: [
            { required: true, message: '请输入新手机号码', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],

        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      // 接口地址
      console.log(this.phone);
      this.changePhoneForm.phoneNumber = this.phone;
    },
    // 方法集合
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            try {
              let res = await this.$http.post(this.$const.common.updateTEL, this.changePhoneForm);
              if (res && res.data) {
                await this.$message.success(this.$PubText.successCom);
                await this.$emit('changePhoneSuccess')
              }
            } catch (e) {
              console.log(e);
            }
          } else {
            return false;
          }
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .forgotPassword_box {
    width: 100%;

    /deep/ .el-form-item {
      padding-left: 5px;
      padding-right: 0;
      border: 1px solid #409eff;

      .el-input {
        input {
          //background-color: rgba(255, 255, 255, 0.7);
          background-color: transparent;
          border: none;
          padding: 0;
          border-radius: 0;

          &:hover {
            border-color: #409eff;
          }

          &::placeholder {
            color: #5c5c5c;
          }
        }
      }
    }

    .verification_code {
      width: 100%;
      height: 40px;
    }

    .submit_btn_box {
      width: 100%;
      height: 60px;
      text-align: center;
    }
  }
</style>